import { render, staticRenderFns } from "./student-course.vue?vue&type=template&id=ce3f72de&scoped=true"
import script from "./student-course.vue?vue&type=script&lang=js"
export * from "./student-course.vue?vue&type=script&lang=js"
import style0 from "./student-course.vue?vue&type=style&index=0&id=ce3f72de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3f72de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce3f72de')) {
      api.createRecord('ce3f72de', component.options)
    } else {
      api.reload('ce3f72de', component.options)
    }
    module.hot.accept("./student-course.vue?vue&type=template&id=ce3f72de&scoped=true", function () {
      api.rerender('ce3f72de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/student-course.vue"
export default component.exports